// React Imports
import * as React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

// App Imports
import {getContractHeaderStandard} from "../Contract/ContractClient";
import WorkIssuanceObligationGrid from "./WorkIssuanceObligation/WorkIssuanceObligationGrid";
import WorkIssuancePaymentGrid from "./WorkIssuancePayment/WorkIssuancePaymentGrid";
import WorkIssuanceExpenseGrid from "./WorkIssuanceExpense/WorkIssuanceExpenseGrid";
import WorkIssuanceFringeGrid from "./WorkIssuanceFringe/WorkIssuanceFringeGrid";
import WorkIssuanceTaxGrid from "./WorkIssuanceTax/WorkIssuanceTaxGrid";
import WorkIssuanceOwedGrid from "./WorkIssuanceOwed/WorkIssuanceOwedGrid";
import WorkIssuanceOffsetsGrid from "./WorkIssuanceOffsets/WorkIssuanceOffsetsGrid";
import WorkIssuanceCalcPayTabs from "./Tabs/CalcPayTabs";
import WorkIssuanceCalcTabs from "./Tabs/CalcTabs";
import WorkIssuancePayTabs from "./Tabs/PayTabs";
import CalcSearchBar from "./Search/CalcSearchBar";
import PaySearchBar from "./Search/PaySearchBar";

import IssuanceMethodTabs from "./Tabs/IssuanceMethodTabs";
import WorkIssuanceCashAccrualLiabilityUltimatesTabs from "./Tabs/CashAccrualLiabilityUltimatesTabs";
import CdpStatsFrame from "./WorkIssuanceStats/CdpStatsFrame";
import Divider from "@mui/material/Divider";
import CrudSnackbar from "../CommonComponents/CrudSnackbar";


// main function
export default function WorkIssuanceFrame(props) {


    // ****************** BEGIN STATES ****************************

    const [contractHeader, setContractHeader] = React.useState([]);
    const [selectorContractName, setSelectorContractName] = React.useState([]);
    const [selectorContractHeader, setSelectorContractHeader] = React.useState([]);

    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const selectorCDPV = useSelector((state) => state.obligationHierarchySlc.value.cdpvId);
    const selectorContractId = useSelector((state) => state.workQueueSlc.value.selectedContractId);
    const selectorProductId = useSelector((state) => state.obligationHierarchySlc.value.myProductId);

    const calcTabState = useSelector((state) => state.workIssuanceSlc.value.calcTabState)
    const payTabState = useSelector((state) => state.workIssuanceSlc.value.payTabState)

    const showObligation = useSelector((state) => state.workIssuanceSlc.value.obligationGridState);
    const showOffset = useSelector((state) => state.workIssuanceSlc.value.offsetsGridState);
    const showOwed = useSelector((state) => state.workIssuanceSlc.value.owedGridState);
    const showPayment = useSelector((state) => state.workIssuanceSlc.value.paymentGridState);
    const showFringe = useSelector((state) => state.workIssuanceSlc.value.fringeGridState);
    const showTax = useSelector((state) => state.workIssuanceSlc.value.taxGridState);
    const showExpense = useSelector((state) => state.workIssuanceSlc.value.expenseGridState);

    const showAccrualObligation = useSelector((state) => state.workIssuanceSlc.value.obligationAccrualGridState)
    const showAccrualOffset = useSelector((state) => state.workIssuanceSlc.value.offsetsAccrualGridState)
    const showAccrualOwed = useSelector((state) => state.workIssuanceSlc.value.owedAccrualGridState)
    const showAccrualPayment = useSelector((state) => state.workIssuanceSlc.value.paymentAccrualGridState)
    const showAccrualFringe = useSelector((state) => state.workIssuanceSlc.value.fringeAccrualGridState)
    const showAccrualTax = useSelector((state) => state.workIssuanceSlc.value.taxAccrualGridState)
    const showAccrualExpense = useSelector((state) => state.workIssuanceSlc.value.expenseAccrualGridState)

    const showLiabilityObligation = useSelector((state) => state.workIssuanceSlc.value.obligationLiabilityGridState)
    const showLiabilityOffset = useSelector((state) => state.workIssuanceSlc.value.offsetsLiabilityGridState)
    const showLiabilityOwed = useSelector((state) => state.workIssuanceSlc.value.owedLiabilityGridState)
    const showLiabilityPayment = useSelector((state) => state.workIssuanceSlc.value.paymentLiabilityGridState)
    const showLiabilityFringe = useSelector((state) => state.workIssuanceSlc.value.fringeLiabilityGridState)
    const showLiabilityTax = useSelector((state) => state.workIssuanceSlc.value.taxLiabilityGridState)
    const showLiabilityExpense = useSelector((state) => state.workIssuanceSlc.value.expenseLiabilityGridState)

    const showUltimateObligation = useSelector((state) => state.workIssuanceSlc.value.obligationUltimateGridState)
    const showUltimateOffset = useSelector((state) => state.workIssuanceSlc.value.offsetsUltimateGridState)
    const showUltimateOwed = useSelector((state) => state.workIssuanceSlc.value.owedUltimateGridState)
    const showUltimatePayment = useSelector((state) => state.workIssuanceSlc.value.paymentUltimateGridState)
    const showUltimateFringe = useSelector((state) => state.workIssuanceSlc.value.fringeUltimateGridState)
    const showUltimateTax = useSelector((state) => state.workIssuanceSlc.value.taxUltimateGridState)
    const showUltimateExpense = useSelector((state) => state.workIssuanceSlc.value.expenseUltimateGridState)

    const showStats = useSelector((state) => state.workIssuanceSlc.value.showStats)

    const selectorVersionMode = useSelector((state) => state.workIssuanceSlc.value.versionMode);
    const selectorVersionStatusId = useSelector((state) => state.workIssuanceSlc.value.versionStatusId);
    const selectorVersionStatusName = useSelector((state) => state.workIssuanceSlc.value.versionStatusName);
    const selectorVersionPeriodEndDate = useSelector((state) => state.workIssuanceSlc.value.versionPeriodEndDate);
    const selectorTestScenarioNumber = useSelector((state) => state.workIssuanceSlc.value.testScenarioNumber );
    const selectorTestScenarioName = useSelector((state) => state.workIssuanceSlc.value.testScenarioName );
    const selectorTestScenarioPropertyId = useSelector((state) => state.workIssuanceSlc.value.testScenarioPropertyId );
    const selectorTestScenarioPropertyName = useSelector((state) => state.workIssuanceSlc.value.testScenarioPropertyName );
    const selectorMatchVersionNumber = useSelector((state) => state.workIssuanceSlc.value.maxVersionNumber);


    // ********************** END STORE ********************************


    // ****************** BEGIN FETCH ****************************

    const fetchContractHeaders = () => {
        // getSampleContracts()
        if (selectorContractId > 0
            // && selectorContractId != 0
        ) {
            getContractHeaderStandard(selectorContractId)

                .then(data => {
                    console.log("My header");
                    console.log(data);
                    setContractHeader(data);
                    setSelectorContractName(data[0].name);
                    setSelectorContractHeader(data[0]);
                })}};

    // ****************** END FETCH ****************************


    // ******************** BEGIN USE EFFECTS *******************

    useEffect(() => {
        console.log("Loading Contracts Header");
        fetchContractHeaders()
        // dispatchData(changeWorkQueue({workQueueCGridRefresh: false})));
    }, []);

    // ******************** END USE EFFECTS *******************


    // ****************** BEGIN RETURN ****************************

    return (
        <Box
            sx={{
                    // width: 600,
                    height: 60}}
        >
            {/*<Stack direction="row" spacing={0}>*/}
            {/*    <IssuanceMethodTabs/>*/}
            {/*    <Box>*/}
            {/*    { calcTabState === true && <CalcSearchBar/>}*/}
            {/*    {  payTabState === true && <PaySearchBar/>}*/}
            {/*    </Box>*/}
            {/*</Stack>*/}
            <Stack direction="row" sx={{ width: '100%', alignItems: 'center' }} spacing={0}>
                <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-start', minWidth: 0 }}>
                    <IssuanceMethodTabs />
                </Box>
                {!showStats &&   <Box sx={{ flex: 0, display: 'flex', justifyContent: 'center', minWidth: 0 }}>
                    {calcTabState && <CalcSearchBar />}
                    {payTabState && <PaySearchBar />}
                </Box>}
                <Box sx={{ flex: 1 }} />
            </Stack>

            {!showStats &&   <Box sx={{height: 40}} />}
            <Divider sx={{marginTop: 0, marginBottom: 0}}/>
            {!showStats &&   <Stack direction="row" spacing={0}>
            <Box
                sx={{
                    width: '100%',
                    display: 'grid',
                    gridTemplateColumns: '1fr auto 1fr', // left fills, center auto, right fills
                    alignItems: 'center',
                    columnGap: 2, // optional spacing between columns
                }}
            >

                <Box sx={{ justifySelf: 'start', minWidth: 0 }}>
                    <WorkIssuanceCalcPayTabs />
                </Box>

                <Box sx={{ justifySelf: 'center', minWidth: 0 }}>
                    {calcTabState && <WorkIssuanceCalcTabs />}
                    {payTabState && <WorkIssuancePayTabs />}
                </Box>

                <Box sx={{ justifySelf: 'end', minWidth: 0 }}>
                    <WorkIssuanceCashAccrualLiabilityUltimatesTabs />
                </Box>
            </Box>
            </Stack>}

            <Box
                sx={{
                    // width: 600,
                    height: 50,
                    paddingLeft: 3
                }}/>
            {selectorVersionMode === "Test" &&
                <Box
                    sx={{
                        backgroundColor: 'primary.main',
                        color: 'primary.contrastText',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontSize: 16,
                        height: 30,
                        px: 3
                    }}
                >Test Scenario {selectorTestScenarioNumber}: {selectorTestScenarioName} using {selectorTestScenarioPropertyName} ({selectorTestScenarioPropertyId})
            </Box>}

            {(showOwed || showAccrualOwed || showLiabilityOwed  || showUltimateOwed) &&     <WorkIssuanceOwedGrid/>}
            {(showObligation || showAccrualObligation || showLiabilityObligation || showUltimateObligation) &&     <WorkIssuanceObligationGrid/>}
            {(showOffset || showAccrualOffset || showLiabilityOffset || showUltimateOffset)  &&     <WorkIssuanceOffsetsGrid/>}
            {(showPayment || showAccrualPayment || showLiabilityPayment || showUltimatePayment) &&   <WorkIssuancePaymentGrid/>}
            {(showFringe || showAccrualFringe || showLiabilityFringe || showUltimateFringe)  &&  <WorkIssuanceFringeGrid/>}
            {(showTax || showAccrualTax || showLiabilityTax || showUltimateTax)  &&  <WorkIssuanceTaxGrid/>}
            {(showExpense || showAccrualExpense || showLiabilityExpense || showUltimateExpense)  &&  <WorkIssuanceExpenseGrid/>}

            {showStats &&     <CdpStatsFrame/>}
            <CrudSnackbar/>
        </Box>

    );

    // ****************** END RETURN ****************************

}


